"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = void 0;
var entity_type_1 = require("../common/entity-type");
Object.defineProperty(exports, "EntityType", { enumerable: true, get: function () { return entity_type_1.EntityType; } });
//# sourceMappingURL=entity-type.js.map